var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-page',{attrs:{"profile":_vm.profile}},[_c('v-topbar',{attrs:{"profile":_vm.profile}}),_vm._v(" "),_c('v-breadcrumb',{attrs:{"steps":[
      { label: 'Profissionais', to: { name: 'client-vibbrants' } },
      { label: 'Perfil' } ]}}),_vm._v(" "),_c('v-container',[_c('v-vibbrant-profile',{attrs:{"user":_vm.vibbrante}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-816297bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/pages/client/vibbrante-profile-page.vue
// module id = null
// module chunks = 